export default __webpack_public_path__ + "static/media/IMG_0019_2_11zon.9cb792dc.jpg";